import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { 
  FaBlog,
  FaNewspaper, 
  FaGraduationCap,
  FaBriefcase
} from 'react-icons/fa';
import './Categories.css';

function Categories() {
  const navigate = useNavigate();

  const categories = [
    { 
      icon: <FaBlog />, 
      title: 'Blog', 
      count: 'Career Insights',
      description: 'Expert advice and industry trends',
      value: 'blog'
    },
    { 
      icon: <FaNewspaper />, 
      title: 'Walk In', 
      count: 'Latest Updates',
      description: 'Industry news and developments',
      value: 'walk in'
    },
    { 
      icon: <FaGraduationCap />, 
      title: 'Internship', 
      count: 'Learning Resources',
      description: 'Step-by-step guides and tips',
      value: 'internship'
    },
    { 
      icon: <FaBriefcase />, 
      title: 'Jobs', 
      count: 'Career Opportunities',
      description: 'Latest job openings and trends',
      value: 'jobs'
    }
  ];

  const handleCategoryClick = (categoryValue) => {
    navigate(`/blogs?category=${categoryValue}`);
  };

  return (
    <section className="categories-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="section-header"
        >
          <h2>Blog Categories</h2>
          <p>Explore our knowledge hub for career growth</p>
        </motion.div>

        <motion.div 
          className="categories-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {categories.map((category, index) => (
            <motion.div
              key={category.title}
              className="category-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 8px 16px rgba(0,0,0,0.1)"
              }}
              onClick={() => handleCategoryClick(category.value)}
              role="button"
              tabIndex={0}
            >
              <div className="category-icon">
                {category.icon}
              </div>
              <h3>{category.title}</h3>
              <p className="category-count">{category.count}</p>
              <p className="category-description">{category.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Categories; 